import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
            About
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            What is pandabuyspreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            A <strong>pandabuyspreadsheet</strong> is a structured product discovery system that organizes curated items into searchable spreadsheets, helping users compare products, prices, and quality efficiently. Instead of browsing endless listings, you get a clean, organized spreadsheet with verified finds across multiple categories — from sneakers and streetwear to luxury accessories and everyday essentials.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full max-w-3xl mx-auto text-sm border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300/60">
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-950">Feature</th>
                <th className="text-left py-3 px-4 font-heading font-semibold text-primary-600">
                  <i className="ri-sparkling-line mr-1"></i>
                  pandabuyspreadsheet
                </th>
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-500">
                  Normal Shopping List
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/60">
                <td className="py-3 px-4 font-medium text-foreground-700">Structure</td>
                <td className="py-3 px-4 text-primary-700 bg-primary-50/50">
                  <i className="ri-check-line text-accent-500 mr-1.5"></i>
                  Advanced filtered data
                </td>
                <td className="py-3 px-4 text-foreground-500">Random items</td>
              </tr>
              <tr className="border-b border-background-200/60">
                <td className="py-3 px-4 font-medium text-foreground-700">Updates</td>
                <td className="py-3 px-4 text-primary-700 bg-primary-50/50">
                  <i className="ri-check-line text-accent-500 mr-1.5"></i>
                  Daily
                </td>
                <td className="py-3 px-4 text-foreground-500">Rare</td>
              </tr>
              <tr className="border-b border-background-200/60">
                <td className="py-3 px-4 font-medium text-foreground-700">Price Comparison</td>
                <td className="py-3 px-4 text-primary-700 bg-primary-50/50">
                  <i className="ri-check-line text-accent-500 mr-1.5"></i>
                  Yes
                </td>
                <td className="py-3 px-4 text-foreground-500">No</td>
              </tr>
              <tr className="border-b border-background-200/60">
                <td className="py-3 px-4 font-medium text-foreground-700">QC Images</td>
                <td className="py-3 px-4 text-primary-700 bg-primary-50/50">
                  <i className="ri-check-line text-accent-500 mr-1.5"></i>
                  Included
                </td>
                <td className="py-3 px-4 text-foreground-500">Not available</td>
              </tr>
              <tr>
                <td className="py-3 px-4 font-medium text-foreground-700">Seller Ratings</td>
                <td className="py-3 px-4 text-primary-700 bg-primary-50/50">
                  <i className="ri-check-line text-accent-500 mr-1.5"></i>
                  Verified
                </td>
                <td className="py-3 px-4 text-foreground-500">Unknown</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read the Full Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}